<template>
  <div name="Datatable">
    <MultiSelect v-if="Pagination" style="padding-top: 10px; padding-bottom: 10px;"
      :fields="columns">
    </MultiSelect>
    <div style="overflow-x: scroll; padding-left: 0px;">
      <div v-if="$slots.default || HeaderSettings" style="margin-bottom: 10px">
        <div style="height:25px;">
          <b-btn class="btn btn-round btn-filter" v-for="fil in currentFilters" :key="fil.db_key" @click="resetFilter(fil.db_key)">
            {{ fil.label }}
            <i class="fa fa-times-circle" />
          </b-btn>
        </div>
        <div style="display: grid;">
          <b-btn class="akribes-btn btn-sm" @click="resetSettings">
            Einstellungen zurücksetzen
          </b-btn>
          <b-btn class="akribes-btn btn-sm" @click="resetAllFilters">
            Alle Filter zurücksetzen
          </b-btn>
          <b-btn v-if="isTrashBin" class="akribes-btn btn-sm" @click="restoreSelection()">
            Ausgewählte Zeilen wiederherstellen
          </b-btn>
          <b-btn v-if="isTrashBin" class="akribes-btn btn-sm" style="background-color: darkred;" @click="deleteSelection(isTrashBin)">
            Ausgewählte Zeilen endgültig löschen
          </b-btn>
          <b-btn v-else class="akribes-btn btn-sm" @click="deleteSelection(isTrashBin)">
            Ausgewählte Zeilen löschen
          </b-btn>
        </div>
        <slot />
      </div>
      <tbl v-bind="$props" style="overflow: visible;"/>
    </div>

    <div v-if="Pagination" class="row" style="margin-top: 10px">
      <div class="col-sm-6" style="white-space: nowrap">
        <strong>
          {{ $i18nForDatatable('Insgesamt') }} {{ total }} {{ $i18nForDatatable(',') }}
        </strong>
        <page-size-select :query="query" :page-size-options="pageSizeOptions" />
      </div>
      <div class="col-sm-6">
        <pagination class="pull-right" :total="total" :query="query" />
      </div>
    </div>
    <ExportButtons v-if="Export" :columns="columns" :query="query" :config="DataConfig" :selection="selection" />
  </div>
</template>
<script>
import HeaderSettings from './HeaderSettings/index.vue'
import MultiSelect from './HeaderSettings/MultiSelect.vue'
import Tbl from './Table/index.vue'
import Pagination from './Pagination.vue'
import PageSizeSelect from './PageSizeSelect.vue'
import ExportButtons from './ExportButtons.vue'
import props from './_mixins/props'
import helpers from '@/mixins/helper-functions'
import api from '@/api'

export default {
  name: 'Datatable',
  mixins: [props],
  data () {
    return {
      englishToGerman: helpers.englishToGerman()
    }
  },
  components: { HeaderSettings, MultiSelect, Tbl, Pagination, PageSizeSelect, ExportButtons },
  created () {
    // init query (make all the properties observable by using `$set`)
    const q = { limit: 20, offset: 0, sort: '', order: '', ...this.query }
    Object.keys(q).forEach(key => { this.$set(this.query, key, q[key]) })
  },
  computed: {
    currentFilters () {
      const query = JSON.parse(JSON.stringify(this.query)) // Copy query
      const filterObj = Object.assign(query.assocFilters, query.freeTextFilters)
      var filters = Object.keys(filterObj).filter(key => filterObj[key] !== undefined)
      return filters.map(fil => {
        return {
          label: this.englishToGerman[fil],
          db_key: fil
        }
      })
    }
  },
  methods: {
    resetFilter (fil) {
      this.$delete(this.query.assocFilters, fil)
      this.$delete(this.query.freeTextFilters, fil)
      this.$set(this.query, 'nChanges', this.query.nChanges + 1)
    },
    async resetSettings () {
      await api.deleteCookies()
      this.$router.go()
    },
    resetAllFilters () {
      this.$set(this.query, 'assocFilters', {})
      this.$set(this.query, 'freeTextFilters', {})
      this.$set(this.query, 'nChanges', this.query.nChanges + 1)
    },
    async restoreSelection () {
      const route = this.$route
      const restoreIDs = this.selection.map(item => item.id)
      const restoreNames = this.selection.map(item => helpers.getName(item))

      // Get confirmation to restore
      var confMessage
      if (restoreNames.length === 1) {
        confMessage = 'Möchten Sie den Eintrag ' + restoreNames[0] + ' wiederherstellen?'
      } else if (restoreNames.length > 1) {
        confMessage = 'Möchten Sie die Einträge ' + restoreNames.join(', ') + ' wiederherstellen?'
      }

      // Restore Items
      if (confirm(confMessage)) {
        const restoreRoute = route.params.table.replace('exudats/', '')
        await api.moveToTrashOrRestore(restoreRoute, restoreIDs, route.path.includes('exudats'), true)
        this.$router.go()
      }
    },
    async deleteSelection (finalRemove) {
      const route = this.$route

      // Test which rows can be deleted
      var deletableItems = await Promise.all(
        this.selection.map(async function (item) {
          var res = await helpers.canBeDeleted(item, route)
          item.canBeDeleted = res
          return item
        })
      )
      deletableItems = deletableItems.filter(item => item.canBeDeleted)
      const deletableIDs = deletableItems.map(val => val.id)

      const undeletableNames = this.selection.filter(item => !deletableIDs.includes(item.id))
        .map(el => helpers.getName(el))

      // Inform about undeletable items
      if (undeletableNames.length === 1) {
        alert('Der Eintrag ' + undeletableNames[0] + ' wird von einem oder mehreren Patienten verwendet und kann daher nicht gelöscht werden.')
      } else if (undeletableNames.length > 1) {
        alert('Die Einträge ' + undeletableNames.join(', ') + ' werden von einem oder mehreren Patienten verwendet und können daher nicht gelöscht werden.')
      }
      const deletableNames = deletableItems.map(el => helpers.getName(el))

      // Get confirmation to delete
      var confMessage
      if (deletableNames.length === 1) {
        confMessage = 'Möchten Sie den Eintrag ' + deletableNames[0] + ' wirklich löschen?'
        if (finalRemove) confMessage += '\nDieser kann danach nicht wiederhergestellt werden!'
      } else if (deletableNames.length > 1) {
        confMessage = 'Möchten Sie die Einträge ' + deletableNames.join(', ') + ' wirklich löschen?'
        if (finalRemove) confMessage += '\nDiese können danach nicht wiederhergestellt werden!'
      }

      // Delete Items
      if (confMessage && confirm(confMessage)) {
        var deleteRoute
        if (finalRemove) {
          deleteRoute = route.params.table.replace('exudats/', '')
          await api.deletePosts(deleteRoute, deletableIDs, route.params.site === 'exudats')
        } else {
          deleteRoute = helpers.getPostResource(route).replace('exudats/', '')
          await api.moveToTrashOrRestore(deleteRoute, deletableIDs, route.name === 'experiment')
        }
        this.$router.go()
      }
    }
  },
  watch: {
    data: {
      handler (data) {
        const { supportNested } = this
        // support nested components feature with extra magic
        if (supportNested) {
          const MAGIC_FIELD = '__nested__'
          data.forEach(item => {
            if (!item[MAGIC_FIELD]) {
              this.$set(item, MAGIC_FIELD, {
                comp: undefined, // current nested component
                visible: false,
                $toggle (comp, visible) {
                  switch (arguments.length) {
                    case 0:
                      this.visible = !this.visible
                      break
                    case 1:
                      switch (typeof comp) {
                        case 'boolean':
                          this.visible = comp
                          break
                        case 'string':
                        case 'object':
                          this.comp = comp
                          this.visible = !this.visible
                          break
                      }
                      break
                    case 2:
                      this.comp = comp
                      this.visible = visible
                      break
                  }
                }
              })
              if (supportNested === 'accordion') {
                this.$watch(
                  () => item[MAGIC_FIELD],
                  nested => {
                    // only one nested component can be expanded at the same time
                    if (data.filter(item => item[MAGIC_FIELD].visible).length < 2) return

                    data.forEach(item => {
                      if (item[MAGIC_FIELD].visible && item[MAGIC_FIELD] !== nested) {
                        item[MAGIC_FIELD].visible = false
                      }
                    })
                  },
                  { deep: true }
                )
              }
              Object.defineProperty(item, MAGIC_FIELD, { enumerable: false })
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>
<style>
/* transition effect: fade */
.akribes-btn {
  margin-top: 5px;
  width: 250px;
}
.akribes-btn:hover {
  color: #1DC7EA !important;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
.btn-filter {
  font-size: 12px !important;
  background-color: rgb(200, 200, 200);
  padding: 2px 2px 2px 10px !important;
  margin-right: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Datatable/src/index.vue